import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('../views/layout'),
      redirect: {name: 'index'},
      children: [
        { // 首页
          path: '/index',
          name: 'index',
          component: () => import('../views/home/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 自定义页面
          path: '/custom',
          name: 'custom',
          component: () => import('../views/custom/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 用户中心
          path: '/userCenter',
          name: 'userCenter',
          component: () => import('../views/userCenter/userCenter'),
          meta: {
            logoText: '',
            searchVisible: false
          },
          children: [
            { // 订单列表你屏幕润
              path: '/myOrder',
              name: 'myOrder',
              component: () => import('../views/userCenter/myOrder/myOrder'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            { // 订单详情
              path: '/orderDetail',
              name: 'orderDetail',
              component: () => import('../views/userCenter/orderDetail/index'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            { // 退款申请
              path: '/RequestARefund',
              name: 'RequestARefund',
              component: () => import('../views/userCenter/RequestARefund/RequestARefund'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            { // 只退款
              path: '/Refund',
              name: 'Refund',
              component: () => import('../views/userCenter/Refund/Refund'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            { // 退款退货
              path: '/RefundReturn',
              name: 'RefundReturn',
              component: () => import('../views/userCenter/Refund/RefundReturn'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            { // 售后订单
              path: '/orderAfterSale',
              name: 'orderAfterSale',
              component: () => import('../views/userCenter/orderAfterSale/orderAfterSale'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            { // 退货单添加物流
              path: '/AddLogistics',
              name: 'AddLogistics',
              component: () => import('../views/userCenter/Refund/AddLogistics'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/signingAddress',
              name: 'signingAddress',
              component: () => import('../views/userCenter/signingAddress/signingAddress'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/userInfo',
              name: 'userInfo',
              component: () => import('../views/userCenter/userInfo/userInfo'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/myEvaluate',
              name: 'myEvaluate',
              component: () => import('../views/userCenter/myEvaluate/index'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/browseRecords',
              name: 'browseRecords',
              component: () => import('../views/userCenter/browseRecords/browseRecords'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/message',
              name: 'message',
              component: () => import('../views/userCenter/messageCenter/message'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/customerService',
              name: 'customerService',
              component: () => import('../views/userCenter/customerService/customer'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/qaList',
              name: 'qaList',
              component: () => import('../views/userCenter/messageCenter/qalist'),
              meta: {
                logoText: '',
                searchVisible: false
              }
            }
          ]
        },
        { // 搜索
          path: '/search',
          name: 'search',
          component: () => import('../views/search/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 店铺主页
          path: '/store',
          name: 'store',
          component: () => import('../views/store/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 分类页面
          path: '/category',
          name: 'category',
          component: () => import('../views/category/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 评价
          path: '/evaluate',
          name: 'evaluate',
          component: () => import('../views/evaluate/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 购物车
          path: '/shopping-trolley',
          name: 'shoppingTrolley',
          component: () => import('../views/shopping-trolley/Cart'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 商品详情
          path: '/productDetail',
          name: 'productDetail',
          component: () => import('../views/product/productDetail'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 下单页面
          path: '/placeOrder',
          name: 'placeOrder',
          component: () => import('../views/placeOrder/CreateOrder'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 下单成功
          path: '/CheckoutSuccess',
          name: 'CheckoutSuccess',
          component: () => import('../views/placeOrder/CheckoutSuccess'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 支付预判
          path: '/prognosis',
          name: 'prognosis',
          component: () => import('../views/placeOrder/prognosis'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价详情
        {
          path: '/evaluateDetail',
          name: 'evaluateDetail',
          component: () => import('../views/evaluateDetail/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 追评
        {
          path: '/addEvaluate',
          name: 'addEvaluate',
          component: () => import('../views/addEvaluate/index'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 登录
        {
          path: '/sign-in',
          name: 'login',
          // component: login
          component: () => import('../views/auth/login'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/forget',
          name: 'forget',
          component: () => import('../views/auth/forget'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/sign-up',
          name: 'register',
          component: () => import('../views/auth/sign-up'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/FAQ',
          name: 'FAQ',
          component: () => import('../views/footer/FAQ'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/About',
          name: 'About',
          component: () => import('../views/footer/About'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        {
          path: '/Help',
          name: 'Help',
          component: () => import('../views/footer/Help'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        { // 测试
          path: '/CeShi',
          name: 'CeShi',
          component: () => import('../views/placeOrder/CeShi'),
          meta: {
            logoText: '',
            searchVisible: true
          }
        }
      ]
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js